/**
 * Which login the current URL belongs to.
 * Public menus live at `/restaurant/<id>`, so the owner app is an explicit list,
 * not "anything under /restaurant".
 */

export const OWNER_APP_PREFIXES = [
  "/restaurant/dashboard",
  "/restaurant/feedback",
  "/restaurant/inventory",
  "/restaurant/orders",
  "/restaurant/order",
  "/restaurant/messages",
  "/restaurant/students",
  "/restaurant/loyalty",
  "/restaurant/loyal-customers",
  "/restaurant/payment-setup",
  "/restaurant/menu",
  "/restaurant/menu-builder",
  "/restaurant/timings",
  "/restaurant/dine-in-tables",
  "/restaurant/dining/console",
  "/restaurant/settings",
  "/restaurant/devices",
  "/restaurant/order-rules",
  "/restaurant/bulk-orders",
  "/restaurant/notifications",
  "/restaurant/page",
  "/restaurant/stories",
  "/restaurant/feed",
  "/restaurant/offers",
  "/restaurant/employees",
  "/restaurant/print",
  "/restaurant/set-password",
  "/boulangerie/add-items",
  "/boulangerie/add-category",
];

export const OWNER_AUTH_PREFIXES = [
  "/restaurant/login",
  "/restaurant/employee-login",
  "/restaurant/signup",
  "/restaurant/forgot-password",
  "/restaurant/reset-password",
  "/restaurant/activate",
];

export function normalizePath(pathname) {
  const raw = String(pathname || "/").split("?")[0].split("#")[0];
  if (raw.length > 1 && raw.endsWith("/")) return raw.slice(0, -1);
  return raw || "/";
}

export function pathMatchesPrefix(pathname, prefix) {
  const path = normalizePath(pathname);
  return path === prefix || path.startsWith(`${prefix}/`);
}

/** @returns {'user' | 'owner' | 'admin'} */
export function authRealmForPath(pathname) {
  const path = normalizePath(pathname);
  if (path === "/admin" || path.startsWith("/admin/")) return "admin";
  const ownerPrefixes = OWNER_APP_PREFIXES.concat(OWNER_AUTH_PREFIXES);
  if (ownerPrefixes.some((prefix) => pathMatchesPrefix(path, prefix))) return "owner";
  return "user";
}

/**
 * Session to load for this URL. Null when that role was already checked,
 * or on the admin logout screen (that page clears the session itself).
 * @returns {'user' | 'owner' | 'admin' | null}
 */
export function bootstrapSessionForPath(pathname, checked) {
  const path = normalizePath(pathname);
  if (path === "/admin/logout") return null;
  const realm = authRealmForPath(path);
  if (realm === "owner") return checked?.ownerSessionChecked ? null : "owner";
  if (realm === "admin") return checked?.adminSessionChecked ? null : "admin";
  return checked?.userSessionChecked ? null : "user";
}
